const SESSION_KEY = 'ogts_logicore_session';

export const DEMO_CREDENTIALS = {
  email: 'admin@ogts.ae',
  password: 'ogts2026',
  displayName: 'Operations Admin',
};

export function readSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.email) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeSession(session) {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSession() {
  sessionStorage.removeItem(SESSION_KEY);
}

export function validateLogin(email, password) {
  const normalizedEmail = email.trim().toLowerCase();
  const normalizedPassword = password.trim();

  if (
    normalizedEmail === DEMO_CREDENTIALS.email.toLowerCase() &&
    normalizedPassword === DEMO_CREDENTIALS.password
  ) {
    return {
      email: DEMO_CREDENTIALS.email,
      displayName: DEMO_CREDENTIALS.displayName,
      role: 'Operations Admin',
      loggedInAt: new Date().toISOString(),
    };
  }

  return null;
}
